import { render, staticRenderFns } from "./SettingEditor.vue?vue&type=template&id=b88f5510&scoped=true&"
import script from "./SettingEditor.vue?vue&type=script&lang=js&"
export * from "./SettingEditor.vue?vue&type=script&lang=js&"
import style0 from "./SettingEditor.vue?vue&type=style&index=0&id=b88f5510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88f5510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCombobox,
  VLayout,
})
